import { useMemo } from 'react';

import { App, AppFamilyNames } from '@cccom/config/app-type';
import { useSettings } from '@cccom/shared/settings';
import { AppCard } from '@cccom/ui/src/components/custom/AppCard';

export function AppList() {
  const { appList } = useSettings();

  const appFamilies = useMemo(() => {
    const family = appList.reduce((prev, app) => {
      const { appFamily } = app;
      const prevFamily = prev.get(appFamily) ?? [];
      prev.set(appFamily, [...prevFamily, app]);
      return prev;
    }, new Map<AppFamilyNames, App[]>());

    return [...family.entries()];
  }, [appList]);

  return (
    <div className="flex h-full flex-col justify-between">
      <div className="m-7">
        {appFamilies.map(([family, apps]) => (
          <section
            key={family}
            className="mb-7 flex flex-col items-start gap-7"
          >
            <h1 className="pb-4 text-3xl font-bold text-gray-500">{family}</h1>

            <div className="flex flex-wrap gap-14 pb-14">
              {apps.map((app) => app && <AppCard key={app.id} app={app} />)}
            </div>

            {appFamilies.length > 1 && <hr className="w-full" />}
          </section>
        ))}
      </div>
    </div>
  );
}
